import { Location, Control, Title, Subtitle, Option } from './styles'

Location.Control = Control
Location.Title = Title
Location.Subtitle = Subtitle
Location.Option = Option

export default Location
